module.exports = __webpack_public_path__ + "img/icn_strongMarker.42e9e30f.svg";